import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllFollowupTypes extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: [],
  }

  apiRequest = params => {
    return new Promise(async resolve => {
    //   this.setState({exportParams: params})
      let data = await this.getAllFollowUpTypes({
        ...params,
        regExFilters:[]
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }

  getAllFollowUpTypes = async()=>{
    let response = await Request.getFollowUpTypes({
        results:1000,
        count:1000,
    })
    return response
  }

  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateFollowUpType(values)
        } else {
            x = await Request.addFollowUpType(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
          })
          notification.success({
            message: this.state.id
              ? `Follow Up Type Updated Successfully`
              : 'Follow Up Type Added successfully'
          })
          if (!this.state.id) {
            form.setFieldsValue({
              name: ''
            })
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  deleteFollowUpType = async data =>{
    this.setState({loading:true})
    await Request.deleteFollowUpDetail(data)
    this.setState({loading:false})
    this.table.current.reload();
    notification.success({
        message: 'Deleted Successfully',
        duration: 20,
        key: `${data._id}-close`
      })
  }

  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  setFollowUpTypeData(followUpId) {
    if(followUpId) {
        Request.followUpTypeById({id:followUpId}).then(
            ({doc,error,message})=>{
                if(!error && doc) {
                    this.setState({
                        id: doc._id,
                        activeTab: '1'
                    })
                this.props.form.setFieldsValue({
                    name:doc.name,

                })
                }else {
                    notification.error({
                      message: 'Error Getting Data',
                      description: message
                    })
                  }
            }
        )
    }
  }

  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

//   componentWillMount() {
    
//   }

  async componentDidMount() {
    await this.getAllFollowUpTypes();
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    const {id} = this.state;

    const inputTypes = {
      fields: [
        {
            label:"Follow Up Type",
            key:"name",
            required:true
        }
      ]
    };

    const columns = [
      {
        title: 'Follow Up Type',
        key: 'name',
      },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          record.businessId?
          <React.Fragment>
            <RightsWrapper myRight={'followUpTypes.edit'}>
              <Tooltip title="Edit Follow Up Type">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setFollowUpTypeData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'followUpTypes.delete'}>
              <Tooltip title="Delete Follow Up Type">
                <Popconfirm
                  title="Are you sure delete this Follow Up Type?"
                  onConfirm={() => {
                    this.deleteFollowUpType({_id: record._id, businessId:record.businessId})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
          :null
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Follow Up Type Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Follow Up Types`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Follow Up Type'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllFollowupTypes
